import { FC, useMemo, useState, MutableRefObject, } from "react";
// 组件
import { CloseOutlined, DownOutlined, LoadingOutlined } from "@ant-design/icons";
// 方法
import classNames from "classnames";
import { validateNoSelectedValue } from "../../utils/dataUtils";
// 常量
import { SelectInputBaseProps, DropdownTableValue } from "../interface";

export type SelectInputActionType = {
  showInputClose: () => void;
  hideInputClose: () => void;
} | undefined;

interface SelectInputProps extends SelectInputBaseProps {
  actionRef: MutableRefObject<SelectInputActionType>;
  /** 是否获取焦点 */
  isFocus?: boolean;
  /** 值 */
  value?: DropdownTableValue;
};

const SelectInput: FC<SelectInputProps> = props => {
  const { actionRef, isFocus, value, placeholder, loading, allowClear, disabled, onClear, } = props;
  const [isInputClose, setIsInputClose] = useState<boolean>(false);
  const [isIconClose, setIsIconClose] = useState<boolean>(false);
  /** 鼠标指针移出Input */
  const handleInputMouseLeave = () => {
    if (disabled) return;
    setIsInputClose(false);
  };
  /** 鼠标指针移入Input */
  const handleInputMouseEnter = () => {
    if (disabled) return;
    setIsInputClose(true);
  };
  /** 鼠标指针移出Icon */
  const handleIconMouseLeave = () => {
    if (disabled) return;
    setIsIconClose(false);
  };
  /** 鼠标指针移入Icon */
  const handleIconMouseEnter = () => {
    if (disabled) return;
    setIsIconClose(true);
  };
  /** 清除选中 */
  const handleClear = () => {
    onClear?.();
  };
  const inputClasses = useMemo(() => {
    return classNames('yb-select-input-inner', {
      'yb-select-input-inner-focus': isFocus,
    });
  }, [isFocus]);
  const iconHtml = useMemo(() => {
    if (loading) {
      return <LoadingOutlined />;
    }
    if (allowClear && validateNoSelectedValue(value) && (isInputClose || isIconClose)) {
      return (
        <CloseOutlined
          className="yb-select-input-close"
          onClick={handleClear}
        />
      );
    }
    return (
      <DownOutlined className="yb-select-input-icon" />
    );
  }, [loading, allowClear, value, isInputClose, isIconClose]);
  actionRef.current = {
    showInputClose: handleInputMouseEnter,
    hideInputClose: handleInputMouseLeave,
  };
  
  return (
    <div className="yb-select-input">
      <div
        className={inputClasses}
        onMouseLeave={handleInputMouseLeave}
        onMouseEnter={handleInputMouseEnter}
      />
      <span className="yb-select-input-prefix">
        {
          (value === undefined || value === null) && (
            <span className="yb-select-input-prefix-placeholder">{placeholder}</span>
          )
        }
      </span>
      <span
        className="yb-select-input-suffix"
        onMouseLeave={handleIconMouseLeave}
        onMouseEnter={handleIconMouseEnter}
      >
        <span className="yb-select-input-suffix-inner">
          {iconHtml}
        </span>
      </span>
    </div>
  );
};

export default SelectInput; 
